import { ApiProperty } from '@nestjs/swagger';
import { IsString, Matches, MaxLength, MinLength } from 'class-validator';

export class ConfigurarPinDto {
  @ApiProperty({ description: 'PIN numérico de 4 a 6 dígitos', example: '1234' })
  @IsString()
  @MinLength(4)
  @MaxLength(6)
  @Matches(/^\d{4,6}$/, { message: 'El PIN debe ser numérico de 4 a 6 dígitos' })
  pin: string;
}
